<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39.6 39.6"><circle cx="12.8" cy="12.8" r="19.8" fill="#f66" transform="translate(7 7)"/><path d="M29.4 20.1v1.5c0 2.2-1.7 4-3.8 4.2v1.9c0 1.1-.9 1.9-1.9 1.9-1.1 0-1.9-.9-1.9-1.9V22c0-1.1.9-1.9 1.9-1.9 1 0 1.9.8 1.9 1.9v1.9c1.1-.2 1.9-1.1 1.9-2.3v-1.5c0-4.2-3.4-7.6-7.6-7.6-4.2 0-7.6 3.4-7.6 7.6v1.5c0 1.1.9 2.1 1.9 2.3V22c0-1.1.9-1.9 1.9-1.9 1 0 1.9.8 1.9 1.9v5.7c0 1.1-.9 1.9-1.9 1.9-1.1 0-1.9-.9-1.9-1.9v-1.9c-2.1-.2-3.8-2-3.8-4.2v-1.5c0-5.3 4.3-9.6 9.6-9.6 5.1 0 9.4 4.4 9.4 9.6" fill="#fff"/></svg>
</template>

<script>
export default {
  name: 'AudioOnIcon'
}
</script>



// WEBPACK FOOTER //
// src/components/icons/AudioOnIcon.vue